module.exports = __webpack_public_path__ + "media/src/assets/Images/PlusIconBlue-10e4cb54ded90f1306a1a1392308de1f.svg";